import React from "react";

import SipPage from "../SipPage";
import { autoServiceMeta, autoService } from "../variables";

const AutoService: React.FC = () => (
  <SipPage meta={autoServiceMeta} section={autoService} />
);

export default AutoService;
